//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SlideItem',
  props: {
    item: {
      type: Object,
      default () {
        /* istanbul ignore next */
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Slide/SlideItem.vue